import React from 'react';
import { config } from "react-spring";
import Carousel from "react-spring-3d-carousel";
import iconSeta from '../../static/img/icons/icon-seta.svg';
import './SliderLetras.scss';

class SliderLetras extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showNavigation: false,
      config: config.gentle,
      offsetRadius: 4,
      goToSlide: 0,
      exibeResultados: this.resultados[0]
    }
  }
  resultados = this.props.data
  slides = [
    {
      key: 1,
      content: <span className="slide-titulo">A</span>
    },
    {
      key: 2,
      content: <span className="slide-titulo">B</span>
    },
    {
      key: 3,
      content: <span className="slide-titulo">C</span>
    },
    {
      key: 4,
      content: <span className="slide-titulo">D</span>
    },
    {
      key: 5,
      content: <span className="slide-titulo">E</span>
    },
    {
      key: 6,
      content: <span className="slide-titulo">F</span>
    },
    {
      key: 7,
      content: <span className="slide-titulo">G</span>
    },
    {
      key: 8,
      content: <span className="slide-titulo">H</span>
    },
    {
      key: 9,
      content: <span className="slide-titulo">i</span>
    },
    {
      key: 10,
      content: <span className="slide-titulo">J</span>
    },
    {
      key: 11,
      content: <span className="slide-titulo">K</span>
    },
    {
      key: 12,
      content: <span className="slide-titulo">L</span>
    },
    {
      key: 13,
      content: <span className="slide-titulo">M</span>
    },
    {
      key: 14,
      content: <span className="slide-titulo">N</span>
    },
    {
      key: 15,
      content: <span className="slide-titulo">O</span>
    },
    {
      key: 16,
      content: <span className="slide-titulo">P</span>
    },
    {
      key: 17,
      content: <span className="slide-titulo">Q</span>
    },
    {
      key: 18,
      content: <span className="slide-titulo">R</span>
    },
    {
      key: 19,
      content: <span className="slide-titulo">S</span>
    },
    {
      key: 20,
      content: <span className="slide-titulo">T</span>
    },
    {
      key: 21,
      content: <span className="slide-titulo">U</span>
    },
    {
      key: 22,
      content: <span className="slide-titulo">V</span>
    },
    {
      key: 23,
      content: <span className="slide-titulo">X</span>
    },
    {
      key: 24,
      content: <span className="slide-titulo">Y</span>
    },
    {
      key: 25,
      content: <span className="slide-titulo">W</span>
    },
    {
      key: 26,
      content: <span className="slide-titulo">Z</span>
    }
  ].map((slide, i) => {
    return {
      ...slide, onClick: () => this.abreLetra(i)
    };
  });
  proximoSlide = () => {
    if(this.state.goToSlide == 25) {
      this.setState ({
        goToSlide: 0,
        exibeResultados: this.resultados[0]
      })
    } else {
      this.setState ({
        goToSlide: this.state.goToSlide + 1,
        exibeResultados: this.resultados[this.state.goToSlide + 1]
      })
    }
  }
  anteriorSlide = () => {
    if( this.state.goToSlide == 0 ) {
      this.setState ({
        goToSlide: 25,
        exibeResultados: this.resultados[25]
      })
    } else {
      this.setState ({
        goToSlide: this.state.goToSlide - 1,
        exibeResultados: this.resultados[this.state.goToSlide - 1]
      })
    }
  }
  abreLetra(index) {
    this.setState({
      goToSlide: index,
      exibeResultados: this.resultados[index]
    })
  }
  render() {
    return (
      <div className="slide-letras">
        <div className="slide-container">
          <div className="slide-container__content">
            <button
              onClick={this.anteriorSlide}
              className="slide-container__seta slide-container__seta--anterior"
            >
              <img src={iconSeta} alt="card arrow" />
            </button>
            <Carousel
              slides={this.slides}
              goToSlide={this.state.goToSlide}
              offsetRadius={this.state.offsetRadius}
              showNavigation={this.state.showNavigation}
              animationConfig={this.state.config}
            />
            <button
              onClick={this.proximoSlide}
              className="slide-container__seta"
            >
              <img src={iconSeta} alt="card arrow" />
            </button>
          </div>
        </div>
        <div className="slide-letras-resultado">
          <ul>
            <li className="espaco-vazio"></li>
            {this.state.exibeResultados.map((res, index)=> {
              return (<li key={index}>{res.nome}</li>)
            })}
            <li className="espaco-vazio"></li>
          </ul>
          <div className="slide-letras-resultado__sombra"></div>
        </div>
      </div>
    )
  }
}
export { SliderLetras }